import { isClosedForDispatchType, isCompletelyClosed } from '~/composables/emergencyBreak'
import { cart } from '~/store/cart'
import { checkout } from '~/store/checkout'
import { shop } from '~/store/shop'
import { webshopSettings } from '~/store/webshopSettings'
import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'
export function isCheckoutDisabled () {
    // function that returns whether checkout is disabled
    const dispatchType = checkout().input.dispatchType
    if (isCompletelyClosed() || isClosedForDispatchType(dispatchType)) {
        // If the shop is completely closed, or closed for the dispatch type, checkout is disabled
        return true
    } else if (!cart().hasCartProducts) {
        return true
    } else if (dispatchType === DispatchTypeOrderBuddy.DELIVER && !meetsMinimumOrderThresholdForDelivery()) {
        // If the dispatch type is delivery and the order does not meet the minimum order threshold, checkout is disabled
        return true
    } else if (dispatchType === DispatchTypeOrderBuddy.PICK_UP && !meetsMinimumOrderThresholdForPickup()) {
        // If the dispatch type is pickup and the order does not meet the minimum order threshold, checkout is disabled
        return true
    }
    return false
}
export function isOrderDisabled () {
    return hasValidPostalCode() || hasUnmetMinimumOrderQuantity() || isCheckoutDisabled()
}

function hasValidPostalCode () {
    const dispatchType = checkout().input.dispatchType
    return dispatchType === DispatchTypeOrderBuddy.DELIVER && hasPostalCode() && !isPostalCodeInRange()
}

export function hasUnmetMinimumOrderQuantity () {
    return Object.values(cart().getCartProducts).some((product: any) => {
        const currentProduct = shop().findProduct(product.id)
        if (currentProduct?.minimumOrderQuantity && currentProduct?.minimumOrderQuantity > 1) {
            return Object.values(cart().getCartProducts).filter((product: any) => product.id === currentProduct?.id).reduce((acc: number, product: any) => acc + product.quantity, 0) < currentProduct?.minimumOrderQuantity
        }
        return false
    })
}
export function hasPostalCode (): boolean {
    return checkout()?.input?.customer?.addressGroup?.postalCode !== ''
}
export function isPostalCodeInRange (): boolean {
    return webshopSettings().getCurrentDeliveryArea !== undefined
}
export function getMinimumOrderThresholdGlobal (): number {
    // TODO: Make a ticket for OB BE to set a default of 0 instead of Maybe<Scalars['Float']['output']>
    return webshopSettings().global?.delivery?.minimumOrderThreshold ?? 0
}
export function getMinimumOrderThresholdForDeliveryCurrentArea (): number {
    // TODO: Make a ticket for OB FE to expose this function + to implement minimum order threshold for pickup of 0 instead of null
    const currentDeliveryArea = webshopSettings().getCurrentDeliveryArea
    return currentDeliveryArea ? currentDeliveryArea.minimumOrderThreshold ?? 0 : 0
}
export function getDeliveryMinimum (): number {
    return getMinimumOrderThresholdForDeliveryCurrentArea() === 0 ? getMinimumOrderThresholdGlobal() : getMinimumOrderThresholdForDeliveryCurrentArea()
}
export function meetsMinimumFreeDeliveryThreshold (): boolean {
    return cart().getCartSubPriceLocal >= webshopSettings()?.getCurrentDeliveryArea?.freeDeliveryThreshold
}
export function meetsMinimumOrderThresholdForDelivery (): boolean {
    const meetsMinimumOrderTresholdGlobal = cart().getCartDiscountedPrice >= getMinimumOrderThresholdGlobal()
    if (hasPostalCode() && isPostalCodeInRange()) {
        // If there is a postcode entered, and it is in range
        if (getMinimumOrderThresholdForDeliveryCurrentArea() === 0) {
            // If there is a no minimum order threshold for the current delivery area then we try to use the global minimum order threshold
            return meetsMinimumOrderTresholdGlobal
        } else {
            // If there is a minimum order threshold for the current delivery area
            return cart().getCartDiscountedPrice >= getMinimumOrderThresholdForDeliveryCurrentArea()
        }
    }
    return meetsMinimumOrderTresholdGlobal
}
export function meetsMinimumOrderThresholdForPickup (): boolean {
    // TODO: Write ticket to implement minimum order threshold for pickup, backend does not support it yet
    return true
}
